import { render, staticRenderFns } from "./ImportClient.vue?vue&type=template&id=be81711c&"
import script from "./ImportClient.vue?vue&type=script&lang=js&"
export * from "./ImportClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports